export default __webpack_public_path__ + "static/react-dev-header-d834f1ac1081ef027c43a97a3d5b0554.jpg";